export const SAVED_NOTIFICATION_ID = "savedNotificationId"
export const SAVED_NOTIFICATION_STATUS = "savedNotification_Status"

